export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Fresh%20modern%20product%20showcase%20with%20diverse%20fashion%20items%20including%20sneakers%20hoodies%20and%20accessories%20artistically%20arranged%20on%20light%20wooden%20surface%2C%20soft%20warm%20natural%20sunlight%2C%20cream%20white%20walls%20with%20subtle%20texture%2C%20green%20plant%20accents%2C%20clean%20Scandinavian%20aesthetic%2C%20editorial%20product%20photography%2C%20airy%20bright%20atmosphere%2C%20warm%20neutral%20color%20palette%2C%20professional%20lifestyle%20composition&width=1600&height=900&seq=allchinabuy-hero-v2&orientation=landscape"
        alt="AllChinaBuySpreadsheet product sourcing with fashion and accessories"
        title="AllChinaBuySpreadsheet – China Product Sourcing Database"
        className="absolute inset-0 w-full h-full object-cover"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
          AllChinaBuySpreadsheet <br />
          <span className="text-primary-300">The Most Updated China Product</span>
          <br />
          Sourcing Spreadsheet
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-10 leading-relaxed">
          Discover verified China product suppliers, pricing data, and curated spreadsheets for sneakers,
          streetwear, electronics, and more — all in one place.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center px-8 py-3.5 text-base font-semibold rounded-lg bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-external-link-line mr-2"></i>
            AllChinaBuy Sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center px-8 py-3.5 text-base font-semibold rounded-lg bg-white/90 text-foreground-900 hover:bg-white transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-bag-3-line mr-2"></i>
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}